import { CDN_GATEWAY_URL, IPFS_GATEWAY_URL } from "./constants";

interface CDNImageOptions {
    width?: number;
    height?: number;
    quality?: string;
    fit?: "contain" | "cover" | "fill" | "inside" | "outside" | "pad" | "crop";
    dpr?: number;
}

/** @return URL to a CDN image with extra resizing/processing options */
export const generateCDNUrl = (
    url: string,
    { width, height, quality, fit, dpr }: CDNImageOptions
): string => {
    let finalUrl = url;

    finalUrl = url.replace(IPFS_GATEWAY_URL, CDN_GATEWAY_URL)

    // Detect cloudflare cdn
    if (url?.startsWith(CDN_GATEWAY_URL)) {
        const optionList = [];
        if (width) {
            optionList.push(`width=${width}`);
        }
        if (height) {
            optionList.push(`height=${height}`);
        }
        if (quality) {
            optionList.push(`quality=${quality}`);
        }
        if (fit) {
            optionList.push(`fit=${fit}`);
        }

        if (dpr) {
            optionList.push(`dpr=${dpr}`);
        }

        const optionString = optionList.join(",");
        finalUrl = url.replace(
            CDN_GATEWAY_URL,
            `https://ipfs.proofofplay.gg/cdn-cgi/image/${optionString}/`
        );
    }

    return finalUrl;
};